import './Setup';
import './Components';

import { default as context } from '@truckdown/systems';
import { IAppUserContext } from './IAppUserContext';

export type { IAppUserContext };
export type { IIconLoader } from './IIconLoader';
export type { INavItem } from './INavItem';
export type { NotificationReceivedHandler } from './Setup/NotificationReceivedHandler';

export { Constants as SystemConstants } from './constants';

context.initialize().then(() => {
    (window as any).isSysInitialized = true;
    console.log('System initialized');
});

export default context as IAppUserContext;
